import { useAuthStore } from 'stores/authStore';

// Only sets the impersonation state (and clears the query cache). Navigation is
// owned by the caller so a single navigation happens after impersonating.
export const useStartImpersonating = () => {
  return useAuthStore((state) => state.startImpersonatingUser);
};
